import { render, staticRenderFns } from "./LegalDocumentEscalationFile.vue?vue&type=template&id=d7b04f38&scoped=true&"
import script from "./LegalDocumentEscalationFile.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentEscalationFile.vue?vue&type=style&index=0&id=d7b04f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b04f38",
  null
  
)

export default component.exports